/**
 * Created by akrio on 2018/3/23.
 */
import {
  USER_TOKEN,
  DEVICE,
  PARAMS,
  LANGUAGE,
  VALIDATE_INFO,
} from "../mutation-types";
import Vue from "vue";

export default {
  state: {
    params: null, // 请求参数
    language: null, // 语言
    validateInfo: null, // 审核信息
    token: null, // 登录所需令牌
  },
  mutations: {
    [USER_TOKEN](state, token) {
      state.token = token;
    },
    [PARAMS](state, params) {
      state.params = params;
    },
    [LANGUAGE](state, language) {
      state.language = language;
    },
    [VALIDATE_INFO](state, validateInfo) {
      state.validateInfo = validateInfo;
    },
  },
  getters: {
    [USER_TOKEN](state) {
      return state.token;
    },
    [DEVICE]() {
      return window.navigator.userAgent.includes("Android") ? "android" : "ios";
    },
    [PARAMS](state) {
      return state.params;
    },
    [VALIDATE_INFO](state) {
      return state.validateInfo;
    },
    [LANGUAGE](state) {
      try {
        // 获取当前设备语言
        let currentLanguage = state.language || navigator.language;
        if (state.language === "{accept_language}") {
          currentLanguage = navigator.language;
        }
        // 判断当前语言是否为中文如果是中文是转一下
        if (currentLanguage === "zh-CN") {
          currentLanguage = "zh-Hans";
        } else if (currentLanguage === "zh-TW") {
          currentLanguage = "zh-Hant";
        }
        // 获取当前所有支持的国际化语言
        const languages = Vue.i18n.locales();
        // 查看当前设置语言是否可以支持
        let language = languages.find((k) => k === currentLanguage);
        console.log("完全匹配查找", language);
        // 如果没有找到匹配项则尝试值拼配地区即前2个单词
        if (!language) {
          console.log("完全匹配查找失败当前语言为", currentLanguage);
          language = languages.find(
            (k) =>
              k.substr(0, 2).toLowerCase() ===
              currentLanguage.substr(0, 2).toLowerCase()
          );
        }
        console.log("計算language", language);
        if (language) {
          return language;
        } else {
          return "en";
        }
      } catch (e) {
        return "en";
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/app.js